// Mock data - Vistora (Corporate only)
export const stats = [
  { value: '500+', label: 'Corporate Projects' },
  { value: 'Pan-India', label: 'Install Network' },
  { value: '03', label: 'Senior Partners' },
];

export const services = [
  {
    num: '01',
    tag: 'PRINT',
    title: 'Vinyl & Wall Graphics',
    prop: 'vinyl',
    desc: 'High-resolution UV & eco-solvent prints for corporate offices — wall graphics, glass frosting, conference room branding, and reception murals.',
    specs: ['UV Print', 'Wall Graphics', 'Glass Frosting'],
  },
  {
    num: '02',
    tag: 'FAB',
    title: 'Signage Fabrication',
    prop: 'channel',
    desc: '3D acrylic letters, ACP signboards, channel letters, LED glow boards, and metal finishing for corporate lobbies, reception desks, and facades.',
    specs: ['Channel Letters', 'ACP Boards', 'LED Illuminated'],
  },
  {
    num: '03',
    tag: 'INSTALL',
    title: 'Nationwide Installation',
    prop: 'monolith',
    desc: 'Certified installation crews across India delivering corporate rollouts with strict project coordination, safety compliance, and QC on every site.',
    specs: ['Pan-India Teams', 'Safety Certified', 'On-Time SLA'],
  },
  {
    num: '04',
    tag: 'TURNKEY',
    title: 'Corporate Turnkey',
    prop: 'lobby',
    desc: 'End-to-end management of corporate rebrands, multi-office rollouts, and campus branding — from concept to installation, one point of contact.',
    specs: ['Multi-Office', 'Rebrand Rollouts', 'End-to-End'],
  },
];

export const portfolio = [
  { id: 1, title: 'Wall Graphics', category: 'Graphics', type: 'wallgraphic' },
  { id: 2, title: 'Wall Art', category: 'Art', type: 'wallart' },
  { id: 3, title: '3D Wall Art', category: '3D Art', type: 'wallart3d' },
  { id: 4, title: 'Hanging Signage', category: 'Hanging', type: 'hanging' },
  { id: 5, title: 'Wall Signage', category: 'Wall', type: 'wallsign' },
  { id: 6, title: 'Door Signage', category: 'Door', type: 'door' },
  { id: 7, title: 'Pylon Signs', category: 'Pylon', type: 'pylon' },
  { id: 8, title: 'Building Signage', category: 'Building', type: 'building' },
  { id: 9, title: 'Workstation Signage', category: 'Workstation', type: 'workstation' },
  { id: 10, title: 'Parking Signage', category: 'Parking', type: 'parking' },
  { id: 11, title: 'Amenities Signage', category: 'Amenities', type: 'amenities' },
  { id: 12, title: 'Facade Signage', category: 'Facade', type: 'facade' },
];

export const whyUs = [
  { num: 'A.01', title: 'Senior-Level Expertise', desc: 'Led by three partners with decades in the signage & printing industry, ensuring seasoned guidance on every corporate mandate.' },
  { num: 'A.02', title: 'Quality Without Compromise', desc: 'Every output undergoes strict QC checks before leaving the facility and again before final installation on-site.' },
  { num: 'A.03', title: 'Fast Turnaround', desc: 'Lightning-speed execution from initial design approval to final, professional installation — without sacrificing quality.' },
  { num: 'A.04', title: 'Pan-India Network', desc: 'A robust network of installers, fabricators, vendors, and logistics partners across the country for seamless corporate rollouts.' },
  { num: 'A.05', title: 'Relationship-Driven', desc: 'We engage with clients as strategic partners, not merely as transactional vendors, ensuring long-term brand success.' },
  { num: 'A.06', title: 'Global Vision', desc: 'Scalable production and logistics systems built to accommodate international campus branding of any scale.' },
];

export const team = [
  { initials: 'CS', role: 'Founder & Senior Partner', name: 'Mr. Chandra Shekhara S S', tag: 'CSG', gender: 'male', bio: 'Jointly responsible for all growth initiatives, leading strategy, operations, and market expansion from concept to completion.' },
  { initials: 'SA', role: 'Co-Founder & Senior Partner', name: 'Ms. Swetha Ashok', tag: 'SA', gender: 'female', bio: 'Jointly responsible for all growth initiatives, leading strategy, operations, and market expansion from concept to completion.' },
  { initials: 'AK', role: 'Co-Founder & Senior Partner', name: 'Mr. Akarsh Kumar M', tag: 'AK', gender: 'male', bio: 'Jointly responsible for all growth initiatives, leading strategy, operations, and market expansion from concept to completion.' },
];

export const coreValues = ['Excellence', 'Integrity', 'Consistency', 'Innovation', 'Customer Focus'];

export const navLinks = [
  { label: 'Overview', href: '#overview', num: '01' },
  { label: 'Services', href: '#services', num: '02' },
  { label: 'Work', href: '#work', num: '03' },
  { label: 'Why Us', href: '#why', num: '04' },
  { label: 'Contact', href: '#contact', num: '05' },
];

export const LOGO = '/vistora-logo.jpg';

export const SOCIALS = {
  linkedin: 'https://www.linkedin.com/company/vistorabrandingsolutions/',
  instagram: 'https://www.instagram.com/vistora_branding_solutions?igsh=MTk4YWdyMThxOGdwMA%3D%3D&utm_source=qr',
  facebook: 'https://www.facebook.com/share/1EuyMbnPdY/?mibextid=wwXIfr',
};

// MOCKED recent social posts (live fetching requires each platform's API + business verification).
// Every card links to the actual profile so users can view real content there.
export const socialPosts = [
  {
    id: 1,
    platform: 'linkedin',
    handle: 'Vistora Branding Solutions',
    time: '2d ago',
    title: 'Corporate Lobby Rebrand \u2014 Bengaluru',
    excerpt: 'Delivered a full lobby signage rebrand for a leading fintech client. Dimensional letters, ACP facade, and directory panels installed within a 72-hour window.',
    tag: 'Case Study',
    accent: '#0A66C2',
  },
  {
    id: 2,
    platform: 'instagram',
    handle: '@vistora_branding_solutions',
    time: '5d ago',
    title: 'Behind the scenes: Channel letters',
    excerpt: 'Fabrication in progress \u2014 dimensional acrylic channel letters getting their final finishing coat before dispatch. Precision + patience.',
    tag: 'Workshop',
    accent: '#E1306C',
  },
  {
    id: 3,
    platform: 'facebook',
    handle: 'Vistora Branding',
    time: '1w ago',
    title: 'Reception desk feature wall unveiling',
    excerpt: 'Proud to share our latest corporate reception installation \u2014 backlit brand mark on a brushed brass mount. Craftsmanship you can feel.',
    tag: 'Install',
    accent: '#1877F2',
  },
  {
    id: 4,
    platform: 'instagram',
    handle: '@vistora_branding_solutions',
    time: '2w ago',
    title: 'Wayfinding rollout \u2014 5 floors, 1 weekend',
    excerpt: 'From concept sketches to on-site installation, our team delivered a complete wayfinding + directory system across a corporate campus.',
    tag: 'Rollout',
    accent: '#E1306C',
  },
  {
    id: 5,
    platform: 'linkedin',
    handle: 'Vistora Branding Solutions',
    time: '3w ago',
    title: 'Meet the team \u2014 Senior partners',
    excerpt: 'Behind every clean install is a team led by three senior partners with decades of combined experience in signage &amp; corporate branding.',
    tag: 'Team',
    accent: '#0A66C2',
  },
  {
    id: 6,
    platform: 'facebook',
    handle: 'Vistora Branding',
    time: '1mo ago',
    title: 'Building facade ACP panel \u2014 Whitefield',
    excerpt: 'A crisp ACP composite facade for a corporate headquarters. Weather-tested, colour-matched, and fully compliant.',
    tag: 'Facade',
    accent: '#1877F2',
  },
];
